"use client"; // Only this file is marked as a client component

import { useEffect } from "react";
import "aos/dist/aos.css";
export default function AOSInitializer() {
  useEffect(() => {
    if (typeof window === "undefined") return;

    const init = async () => {
      try {
        const mod = await import("aos");
        mod.default.init();
      } catch (e) {
        console.error("AOS init failed:", e);
      }
    };

    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(() => init());
      return;
    }

    const t = setTimeout(() => init(), 1500);
    return () => clearTimeout(t);
  }, []);
    return null; // This component doesn't render anything
}
